import { PredictiveSearch, QuantitySelector } from "//wabihome.com/cdn/shop/t/50/assets/theme.js?v=52308352834960509651788851655"; // Asegúrate de que este import es correcto

// Extender la clase QuantitySelector
class WabiQuantitySelector extends QuantitySelector {
  connectedCallback() {
    super.connectedCallback();
    
    // Obtener referencia al input de cantidad
    const quantityInputs = this.querySelectorAll('.quantity-selector__button');
    if (quantityInputs){
      quantityInputs.forEach((item) => {
        item.addEventListener("click", (e) => {
          
          
          setTimeout(() => { // Cambiado a función de flecha
            const input = document.querySelector('input[name=quantity]');
            const inputEvent = new Event('input', {
              bubbles: true, // Permitir que el evento se propague
              cancelable: true // Permitir que el evento se pueda cancelar
            });
            input.dispatchEvent(inputEvent);
          }, 500);
        });
      });
    }
  }
}

class WabiPredictiveSearch extends PredictiveSearch {
  supportsPredictiveApi() {
    return false;
  }
}

// Definir el nuevo elemento personalizado
window.customElements.define('wabi-quantity-selector', WabiQuantitySelector);
window.customElements.define('wabi-predictive-search', WabiPredictiveSearch);
